import React from 'react';
import { toastr } from 'react-redux-toastr';
import { Column } from '../lib_react_adminlte/componentes/Table.jsx';
import LabeledInput from '../lib_react_adminlte/componentes/LabeledInput.jsx';
import Cadastro from './Cadastro.jsx';
import Api from '../utils/Api.jsx';
import RecordSelect from '../lib_react_adminlte/componentes/RecordSelect.jsx';
import Button from '../lib_react_adminlte/componentes/Button.jsx';

/**
 * Componente de cadastro de funcionário.
 */
export default class CadastroUsuario extends React.Component {

  state = {
    registros: [],
    registro: this.getRegistroLimpo(),
    empresasNaoAdicionadas: [],
    empresasAdicionadas: [],
    mostrarSenha: false,
  };

  async componentWillMount() {
    this.getEmpresasNaoAdicionadas('');
  }

  onChange(prop, event) {
    this.setState({
      registro: {
        ...this.state.registro,
        [prop]: event.target ? event.target.value : event,
      },
    });
    if (prop === 'senha') {
      this.setState({
        mostrarSenha: true,
      });
    }
  }
  async getEmpresasNaoAdicionadas(empresas) {
    const ret = await Api.getEmpresasNaoAdicionadas(empresas);
    if (!ret.status) {
      console.log(ret);
      return toastr.error('Atenção!', 'Erro ao buscar as empresas', 2);
    }
    this.setState({ empresasNaoAdicionadas: ret.dados, constanteNao: ret.dados });
  }

  /**
   * Retorna a mensagem de confirmação ao excluir.
   */
  getMsgExcluir() {
    return 'Tem certeza que deseja excluir ' + this.state.registro.nome_usuario + ' ?';
  }

  /**
   * Retorna um registro limpo.
   */
  getRegistroLimpo() {
    return {
      nome_usuario: '',
      email: '',
      senha: '',
      empresasAdicionadas: [],
      mostrarSenha: false,
    };
  }

  /**
   * Retorna as ações da tabela.
   */
  async getRegistros(filtro) {
    const ret = await Api.getUsuarios(filtro);
    if (!ret.status) {
      console.log(ret);
      return toastr.error('Erro!', ret.erro.error_message);
    }
    this.setState({ itemSelecionado: null });
    this.setState({ registros: ret.dados.usuario });
    return ret;
  }


  /**
   * Retorna o registro.
   */
  getRegistro() {
    const copy = Object.assign({}, this.state.registro);
    copy.empresasAdicionadas = this.state.empresasAdicionadas;

    if (copy.senha == '' || copy.senha.length > 20) { delete copy.senha; }
    console.log(copy.id, copy.senha);
    return copy;
  }
  /**
   * seta o registro com o item recebido da lista da tabela
   * @param {} item 
   */
  setRegistro(item) {
    this.setState({ registro: item, empresasAdicionadas: item.empresas, mostrarSenha: false });
    this.getEmpresasNaoAdicionadas(item.empresas);
    console.log(item);
  }

  /**
   * Limpa o registro atual.
   */
  limparRegistro() {
    this.setState({
      registro: this.getRegistroLimpo(),
      itemSelecionado: null,
    });
  }

  /**
   * Renderiza as colunas que aparecerão no grid da listagem.
   */
  renderColunas() {
    return [
      <Column key={1} field="nome_usuario" header="Nome do Usuario" style={{ width: "50%" }} />,
      <Column key={2} field="email" header="E-mail" style={{ width: "50%" }} />,
    ];
  }

  renderColunasRecordSelect() {
    return [
      <Column key={1} field="razao_social" header="Razão social" />,
      <Column key={2} field="doc_federal" header="CNPJ" />,
    ];
  }

  gerarSenha = () => {
    const letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    const numeros = "0123456789";
    const especiais = "!@#$%^&*()_+[]{}|;:,.<>?";
    const todosCaracteres = letras + numeros + especiais;

    const tamanhoMinimo = 8;
    const tamanhoSenha = tamanhoMinimo + Math.floor(Math.random() * 5); // Tamanho variável (8 a 12 caracteres)
    let senha = "";

    // Garantir pelo menos uma letra
    senha += letras.charAt(Math.floor(Math.random() * letras.length));

    // Garantir pelo menos um caractere especial
    senha += especiais.charAt(Math.floor(Math.random() * especiais.length));

    // Preencher o restante com caracteres aleatórios
    for (let i = senha.length; i < tamanhoSenha; i++) {
      senha += todosCaracteres.charAt(Math.floor(Math.random() * todosCaracteres.length));
    }

    // Embaralhar a senha 
    senha = senha.split('').sort(() => Math.random() - 0.5).join('');

    this.setState((prevState) => ({
      registro: {
        ...prevState.registro,
        senha,
      },
      mostrarSenha: true,
    }));

    // Copia a senha para a área de transferência
    navigator.clipboard.writeText(senha).then(
      () => {
        toastr.success("Senha copiada para a área de transferência!");
      },
      (err) => {
        toastr.warning("Erro ao copiar para a área de transferência", err);
      }
    );
  };




  /**
   * Renderiza o formulário de inclusão/alteração.
   */
  renderForm() {

    return (
      <div>
        <div>
          <div className="row mt-5">
            <div className="col-sm-5">
              <LabeledInput label="Nome do Usuario:"
                value={this.state.registro.nome_usuario}
                onChange={this.onChange.bind(this, 'nome_usuario')} />
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-sm-5">
              <LabeledInput label="E-mail:"
                uppercase='false'
                value={this.state.registro.email}
                onChange={this.onChange.bind(this, 'email')} />
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-sm-5">
              <LabeledInput label="Senha:"
                uppercase='false'
                placeholder='Segredo'
                value={this.state.mostrarSenha ? this.state.registro.senha : ''}
                onChange={this.onChange.bind(this, 'senha')} />
            </div>
            <div className="input-group-append" style={{ marginTop: "25px", }}>
              <Button
                icon="fa-key"
                className="btn-primary"
                onClick={this.gerarSenha}
                title="Clique para gerar uma senha aleatória"
              />
            </div>

          </div>
        </div>

        <RecordSelect listaNaoAdicionado={this.state.empresasNaoAdicionadas}
          listaAdicionado={this.state.empresasAdicionadas}
          tituloNaoAdicionado="Não adicionados"
          tituloAdicionado="Adicionados"
          colunas={this.renderColunasRecordSelect()}
          constanteNao={this.state.constanteNao}
          onChangeNaoAdicionado={(l) => this.setState({ empresasNaoAdicionadas: l })}
          onChangeAdicionado={(l) => {
            this.setState({ empresasAdicionadas: l });
          }} />
      </div>


    );
  }

  render() {

    return (
      <div>
        <Cadastro tabela="usuario"
          pk="id"
          titulo="Cadastro de Usuarios"

          tableSelecionavel
          itemSelecionadoTable={this.state.itemSelecionado}
          onSelecionarItemTable={e => this.setState({ itemSelecionado: e })}

          renderForm={this.renderForm.bind(this)}
          renderColunas={this.renderColunas.bind(this)}


          getMsgExcluir={this.getMsgExcluir.bind(this)}
          getRegistros={this.getRegistros.bind(this)}
          getRegistro={this.getRegistro.bind(this)}
          setRegistro={this.setRegistro.bind(this)}

          limparRegistro={this.limparRegistro.bind(this)}
          ref={e => this.cadastro = e} />


      </div>
    );
  }

}




// WEBPACK FOOTER //
// ./src/componentes/CadastroUsuario.jsx